import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import api from '@/lib/api';

const I18nContext = createContext(null);

const FALLBACK = {
  en: { appName: 'GharSetGo', home: 'Home', bookings: 'Bookings', profile: 'Profile', scan: 'AI Scan', bookNow: 'Book Now', nearbyWorkers: 'Nearby Workers', welcome: 'Welcome' },
};

const LANGS = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'hi', label: 'हिन्दी',   flag: '🇮🇳' },
  { code: 'gu', label: 'ગુજરાતી', flag: '🇮🇳' },
  { code: 'mr', label: 'मराठी',   flag: '🇮🇳' },
];

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('qk_lang') || 'en');
  const [dict, setDict] = useState(FALLBACK.en);

  const load = useCallback(async (l) => {
    try { const r = await api.get(`/i18n/${l}`); setDict(r.data || FALLBACK.en); }
    catch { setDict(FALLBACK.en); }
  }, []);

  useEffect(() => { load(lang); }, [lang, load]);

  const setLang = (l) => { localStorage.setItem('qk_lang', l); setLangState(l); };
  const t = (key) => dict[key] || FALLBACK.en[key] || key;

  return <I18nContext.Provider value={{ lang, setLang, t, langs: LANGS }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n needs I18nProvider');
  return ctx;
}
